import React, { useState } from "react";
import { IconButton, useTheme } from "@fluentui/react";

export interface CollapsableCardHeaderComponentProps {
  isExpanded: boolean;
  setExpanded: (nextValue: boolean) => void;
}

export const CollapsableCardDefaultHeaderComponent = ({
  isExpanded,
  setExpanded,
}: CollapsableCardHeaderComponentProps) => {
  const theme = useTheme();

  return (
    <IconButton
      styles={{
        root: {
          color: theme.palette.neutralPrimary,
          transform: isExpanded ? "rotateX(180deg)" : "",
          transition: "500ms linear all",
        },
        rootHovered: {
          color: theme.palette.neutralDark,
        },
      }}
      iconProps={{ iconName: "ChevronDown" }}
      ariaLabel={isExpanded ? "Close popup modal" : "Open popup modal"}
      onClick={() => {
        setExpanded(!isExpanded);
      }}
    />
  );
};

export interface CollapsableCardProps {
  headerComponent: (props: CollapsableCardHeaderComponentProps) => React.ReactElement;
  externalState?: { isExpanded: boolean; setExpanded: (x: boolean) => void };
}

export const CollapsableCard: React.FunctionComponent<CollapsableCardProps> = (props) => {
  const [_isExpanded, _setExpanded] = useState<boolean>(false);

  const isExpanded = props.externalState?.isExpanded ?? _isExpanded;
  const setExpanded = props.externalState?.setExpanded ?? _setExpanded;

  return (
    <div className={"card"}>
      {props.headerComponent({ isExpanded, setExpanded })}
      {isExpanded ? props.children : null}
    </div>
  );
};
